// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fees-for-stop-form .el-form--inline {\n  display: flex;\n  justify-content: space-between;\n}\n.fees-for-stop-form .el-form-item.date-time-range .el-input__inner {\n  width: 47em;\n}\n.fees-for-stop-form .el-form-item.date-time .el-input__inner {\n  padding-right: 14px;\n}\n.fees-for-stop-form .parent_Box {\n  padding-right: 34px;\n}", ""]);
// Exports
module.exports = exports;
